import request from '../../utils/request';
import options from './options';

const urlPath = (url, path) => `${url}${path}`;

export const getCalculatorsDepth = filter => request.get({
    url: urlPath(options.apiUrl, filter)
});

export const getCalculatorsDepthItem = id => request.get({
    url: urlPath(options.apiUrl, `${id}/`)
});